import axiosInstance from "./axios";
import {
  Product,
  CreateProductPayload,
  UpdateProductPayload,
} from "./models/product.models";

const apiUrl = import.meta.env.VITE_BACKEND_API_URL;

export const fetchProduct = async (bearerToken, ean): Promise<Product[]> => {
  try {
    // ean query param
    const response = await axiosInstance.get(
      `${apiUrl}/Products/products?eans=${ean}`,
      {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Failed to fetch company:", error);
    throw error;
  }
};

export const fetchSingleProductWithIdentifier = async (
  bearerToken: string,
  companyId: number,
  identifier: string
): Promise<Product> => {
  try {
    const response = await axiosInstance.get(
      `${apiUrl}/Products/${companyId}/products/${identifier}`,
      {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Failed to fetch product with identifier:", error);
    throw error;
  }
};

export const fetchProductsWithIdentifiers = async (
  bearerToken: string,
  companyId?: number,
  identifiers?: string[]
): Promise<Product[]> => {
  try {
    if (!identifiers || identifiers.length === 0) {
      return [];
    }
    const identifiersParam = identifiers.join(",");
    const response = await axiosInstance.get(
      `${apiUrl}/Products/${companyId}/products?identifiers=${identifiersParam}`,
      {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Failed to fetch products with identifiers:", error);
    throw error;
  }
};

export const fetchProducts = async (
  bearerToken: string,
  companyId: number,
  page: number = 1
): Promise<Product[]> => {
  try {
    const response = await axiosInstance.get(
      `${apiUrl}/Products/${companyId}/products?page=${page}`,
      {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Failed to fetch products:", error);
    throw error;
  }
};

export const createProduct = async (
  bearerToken: string,
  payload: CreateProductPayload
): Promise<Product> => {
  try {
    const response = await axiosInstance.post(
      `${apiUrl}/Products/${payload.companyId}/products`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Failed to create product:", error);
    throw error;
  }
};

export const updateProduct = async (
  bearerToken: string,
  payload: UpdateProductPayload
): Promise<Product> => {
  try {
    const response = await axiosInstance.patch(
      `${apiUrl}/Products/${payload.companyId}/products`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Failed to create update package:", error);
    throw error;
  }
};
